import { Button } from '@talentmesh/ui/components/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader } from '@talentmesh/ui/components/dialog';
import { useInviteCandidateContext } from '../Contexts/InviteCandidateContext';
import PopupDialogTitle from './PopupDialogTitle';
import UIStrings from '@/Utils/UIStrings';

function PreviewInvitationEmailDialog() {
    const { previewInvitationEmailDialogOpen, setPreviewInvitationEmailDialogOpen } = useInviteCandidateContext();

    return (
        <Dialog open={previewInvitationEmailDialogOpen} onOpenChange={setPreviewInvitationEmailDialogOpen}>
            <DialogContent showCloseButton={false} className="max-w-lg gap-4">
                <DialogHeader>
                    <PopupDialogTitle
                        title={UIStrings.PreviewRecruitmentInvitationEmail}
                        close={() => setPreviewInvitationEmailDialogOpen(false)}
                    />
                    <DialogDescription className="sr-only">
                        {UIStrings.PreviewRecruitmentInvitationEmail}
                    </DialogDescription>
                </DialogHeader>
                <div className="bg-primary/10 flex flex-col gap-4 overflow-y-auto rounded-xl px-4 py-7 text-center">
                    <p className="text-foreground text-sm">
                        {`${UIStrings.Hi} `}
                        <span className="font-bold">{`${UIStrings.ApplicantsNamePlaceholder},`}</span>
                    </p>
                    <p className="text-foreground text-sm">
                        <span className="font-bold">{`${UIStrings.RecruitersNamePlaceholder} `}</span>
                        {`${UIStrings.From} `}
                        <span className="font-bold">
                            {`${UIStrings.CompanysNamePlaceholder} ${UIStrings.HasInvitedYouToTakeATalentMeshAssessment} `}
                        </span>
                        {UIStrings.AsPartOfTheirRecruitmentProcess}
                        <br />
                        <br />
                        {`${UIStrings.ThePurposeOfThisAssessmentIsToGenerate} `}
                        <span className="font-bold">{UIStrings.ItsAnOpportunityToShowcaseYourUnique}</span>
                        {UIStrings.WhichCanBeHardToEvaluateSolelyFromReadingYourCV}
                    </p>
                    <img
                        alt="Invitation"
                        className="mx-auto max-w-full outline-none"
                        src="https://8513883.fs1.hubspotusercontent-na1.net/hub/8513883/hubfs/Invitation.png?width=1120&amp;upscale=true&amp;name=Invitation.png"
                        width={560}
                    />
                    <p className="text-foreground text-sm font-bold">
                        {UIStrings.StartYourAssessmentNowOrContinueWhereYouLeftOff}
                    </p>
                    <Button variant="default" className="mx-auto w-fit">
                        {UIStrings.GoToAssessment}
                    </Button>
                    <p className="text-foreground text-sm">{UIStrings.OrCopyAndPasteThisUrlIntoYourBrowser}</p>
                    <span className="text-foreground text-sm font-bold">{UIStrings.AssessmentUrlPlaceholder}</span>
                    <p className="text-foreground text-sm">
                        {UIStrings.AllTheBest}
                        <br />
                        {UIStrings.TheTalentMeshTeam}
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default PreviewInvitationEmailDialog;
